/**
 * Frontend üçün sadə loglama köməkçi funksiyası
 * Production-da debug loglarını söndürür, yalnız xətaları saxlayır
 */

type LogLevel = 'debug' | 'info' | 'warn' | 'error'

class Logger {
  private isDevelopment = import.meta.env.DEV

  private shouldLog(level: LogLevel): boolean {
    if (this.isDevelopment) return true
    // Production-da yalnız xəbərdarlıqlar və xətaları loglayırıq
    return level === 'warn' || level === 'error'
  }

  debug(message: string, ...args: any[]) {
    if (this.shouldLog('debug')) {
      console.log(`[DEBUG] ${message}`, ...args)
    }
  }

  info(message: string, ...args: any[]) {
    if (this.shouldLog('info')) {
      console.info(`[INFO] ${message}`, ...args)
    }
  }

  warn(message: string, ...args: any[]) {
    if (this.shouldLog('warn')) {
      console.warn(`[WARN] ${message}`, ...args)
    }
  }

  error(message: string, error?: any, ...args: any[]) {
    if (this.shouldLog('error')) {
      console.error(`[ERROR] ${message}`, error, ...args)
    }
  }

  // WebSocket hadisələri üçün xüsusi metod
  socket(event: string, data?: any) {
    if (this.isDevelopment) {
      console.log(`🔌 [Socket] ${event}`, data || '')
    }
  }
}

export const logger = new Logger()

